import { render, staticRenderFns } from "./AbonementsKinds.vue?vue&type=template&id=4718216e&"
import script from "./AbonementsKinds.vue?vue&type=script&lang=js&"
export * from "./AbonementsKinds.vue?vue&type=script&lang=js&"
import style0 from "@/styles/Abonements.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports